import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorTokenSplash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M4.5 17.25a.75.75 0 0 0-.67.415l-1.5 3A.75.75 0 0 0 3 21.75h18a.75.75 0 0 0 .67-1.085l-1.5-3a.75.75 0 0 0-.67-.415h-2.25a.75.75 0 0 0 0 1.5h1.787l.75 1.5H4.213l.75-1.5H6.75a.75.75 0 0 0 0-1.5H4.5Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12.935 4.155a1.284 1.284 0 0 0-1.87 0L4.15 11.328a1.473 1.473 0 0 0 0 2.02l5.707 5.902h4.322l5.668-5.9v-.001a1.473 1.473 0 0 0 0-2.021l-6.912-7.173Zm-2.95-1.041a2.784 2.784 0 0 1 4.03 0l6.914 7.173a2.973 2.973 0 0 1 0 4.102l-6.11 6.361H9.221l-6.15-6.36a2.973 2.973 0 0 1 0-4.103l6.914-7.173Z"
    />
    <path
      fill="#F7A600"
      d="M11.939 6.893a.75.75 0 0 1 .75.75v.536h1.178a.75.75 0 0 1 0 1.5h-2.893a.857.857 0 0 0 0 1.714h1.929a2.357 2.357 0 0 1 0 4.714h-.214v.536a.75.75 0 0 1-1.5 0v-.536H10.01a.75.75 0 0 1 0-1.5h2.893a.857.857 0 1 0 0-1.714h-1.929a2.357 2.357 0 1 1 0-4.714h.215v-.536a.75.75 0 0 1 .75-.75Z"
    />
  </svg>
);
export default SvgTwoColorTokenSplash;
